'use strict';
module.exports = require('./ConfirmDialog.vue');